/** 공통 아이콘 */
export const commonImage = {
  calender: '/assets/icons/icon-calender.svg',
  laguage: '/assets/icons/icon-laguage.svg',
  logout: '/assets/icons/icon-logout.svg',
  mypage: '/assets/icons/icon-mypage.svg',
  modalClose: '/assets/icons/icon-close.svg',
  carouselStop: '/assets/icons/icon-stop.svg',
  carouselPlay: '/assets/icons/icon-play.svg',
  search: '/assets/icons/icon-search.svg',
  searchWhite: '/assets/icons/icon-search-white.svg',
  exchange: '/assets/icons/icon-exchange.svg',
  cancel: '/assets/icons/icon-cancel.svg',
  camera: '/assets/icons/icon-camera.svg',
  cctv: '/assets/icons/icon-cctv.svg',
  delete: '/assets/icons/icon-delete.svg',
  file: '/assets/icons/icon-file.svg',
  fileUploadOff: '/assets/icons/icon-upload-file.svg',
  fileUploadOn: '/assets/icons/icon-upload-file-on.svg',
  alarm: '/assets/icons/icon-alarm.svg',
  fileDownload: '/assets/icons/icon-file-download.svg',
  dummyV1: '/assets/image/image_dummy_1.jpg',
  download: '/assets/icons/icon-download.svg',
  gsMapDummy: '/assets/image/image_gs_dashboard_dummy.png',
  gsHeader: '/assets/image/chart/image-gs-header.svg',
  gsBorder: '/assets/image/chart/image-chart-border.svg',
  gsCardBorder: '/assets/image/chart/image-chart-card-border.svg',
  checkboxOn: '/assets/icon/checkbox/icon-checkbox-on.svg',
  checkboxOff: '/assets/icon/checkbox/icon-checkbox-off.svg'
};

/** CI 이미지 */
export const ciImage = {
  gsilLogoNormal: '/assets/icons/logo/gsil-logo-normal.svg',
  gsilLogoPointcolor: '/assets/icons/logo/gsil-logo-pointcolor.svg',
  gsilLogoWhite: '/assets/icons/logo/gsil-logo-white.svg',
  logo4s: '/assets/icons/logo/logo-4s.svg',
  logoSamsungWhite: '/assets/icons/logo/logo-samsung-white.svg',
  logoGsWhite: '/assets/icons/logo/logo-gsca2-white2.svg',
  logo4sBlack: '/assets/icons/logo/icon-logo-4s-black.svg',
  logoSamsung: '/assets/icons/logo/icon-logo-samsung-v2.svg',
  logoSamsungV2: '/assets/icons/logo/icon-logo-samsung-v2.svg',
  logoGsil: '/assets/icons/logo/icon-logo-gsil.svg',
  logoGsilWhite: '/assets/icons/logo/icon-logo-gsil-white.svg',
  logoSafetyWhite: '/assets/icons/logo/icon-logo-safety100-white.svg'
};

/** 메뉴 아이콘 */
export const menuIcons = {
  menuClose: '/assets/icons/menu/icon-menu-close.svg',
  menuOpen: '/assets/icons/menu/icon-menu-open.svg',
  dashboard: '/assets/icons/menu/icon-menu-dashboard.svg',
  notice: '/assets/icons/menu/icon-menu-notice.svg',
  pjt: '/assets/icons/menu/icon-menu-pjt.svg',
  company: '/assets/icons/menu/icon-menu-company.svg',
  user: '/assets/icons/menu/icon-menu-user.svg',
  passport: '/assets/icons/menu/icon-menu-passport.svg',
  ptw: '/assets/icons/menu/icon-menu-ptw.svg',
  tbm: '/assets/icons/menu/icon-menu-tbm.svg',
  weather: '/assets/icons/menu/icon-menu-weather.svg',
  cctv: '/assets/icons/menu/icon-menu-cctv.svg',
  system: '/assets/icons/menu/icon-menu-system.svg'
};

/** 화살표 아이콘 */
export const arrowImage = {
  arrowCircle: '/assets/icons/arrow/icon-arrow-circle.svg',
  arrowDropDown: '/assets/icons/arrow/icon-arrow-dropdown.svg',
  arrowNext: '/assets/icons/arrow/icon-arrow-next.svg',
  arrowNextPrimary: '/assets/icons/arrow/icon-arrow-next-primary.svg',
  arrowPrev: '/assets/icon/arrow/icon-arrow-prev.svg',
  arrowTriangle: '/assets/icon/arrow/icon-arrow-triangle.svg',
  arrowTriangleWhite: '/assets/icon/arrow/icon-arrow-triangle-white.svg'
};

/** 로그인 이미지 */
export const loginImage = {
  image1: '/assets/image/login/main1.webp',
  image2: '/assets/image/login/main2.webp',
  image3: '/assets/image/login/main3.webp'
};

/**
 * 로그인 배경 이미지
 */
export const loginImages = [
  {
    src: loginImage.image1
  },
  {
    src: loginImage.image2
  },
  {
    src: loginImage.image3
  }
];

/** Clock Image */
export const clockImages = {
  clock: '/assets/image/clock/image-clock-bg.png',
  hour: '/assets/image/clock/image-clock-hour.svg',
  minute: '/assets/image/clock/image-clock-minute.svg',
  second: '/assets/image/clock/image-clock-second.svg'
};

export const environmentIcon = {
  common: '/assets/image/environment/common.svg',
  humidity: '/assets/image/environment/humidity.svg',
  barometer: '/assets/image/environment/barometer.svg',
  rain: '/assets/image/environment/rain.svg',
  setting: '/assets/image/environment/setting.svg',
  temperature: '/assets/image/environment/temparature.svg',
  wind: '/assets/image/environment/wind.svg',
  windDirection: '/assets/image/environment/wind_direction.svg',
  humidity2: '/assets/icon/weather/icon-humidity.svg',
  wind2: '/assets/icon/weather/icon-wind.svg',
  rain2: '/assets/icon/weather/icon-umbrella.svg'
};

export interface WeatherIcon {
  [key: string]: string;
}

export const weatherIcons: WeatherIcon = {
  '01d': '/assets/icon/weather/01d.svg',
  '02d': '/assets/icon/weather/02d.svg',
  '03d': '/assets/icon/weather/03d.svg',
  '04d': '/assets/icon/weather/04d.svg',
  '09d': '/assets/icon/weather/09d.svg',
  '10d': '/assets/icon/weather/10d.svg',
  '11d': '/assets/icon/weather/11d.svg',
  '13d': '/assets/icon/weather/13d.svg',
  '50d': '/assets/icon/weather/50d.svg',
  '01n': '/assets/icon/weather/01d.svg',
  '02n': '/assets/icon/weather/02d.svg',
  '03n': '/assets/icon/weather/03d.svg',
  '04n': '/assets/icon/weather/04d.svg',
  '09n': '/assets/icon/weather/09d.svg',
  '10n': '/assets/icon/weather/10d.svg',
  '11n': '/assets/icon/weather/11d.svg',
  '13n': '/assets/icon/weather/13d.svg',
  '50n': '/assets/icon/weather/50d.svg'
};

// export const findWeatherIcon = (iconName: string) => {
//   const iconTitle = iconName.replaceAll('n', 'd'.replaceAll('.png', '').replaceAll(' ', ''));
//   return weatherIcons[iconTitle];
// };
